import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Fade, IconButton, Link } from "@mui/material";
import { Info } from "@mui/icons-material";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  width: 400,
  maxWidth: "90vw",
  // borderRadius: 3
};

function InfoModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="info-button surface">
      <IconButton onClick={handleOpen} aria-label="information" sx={{width: 32, height: 32}}>
        <Info />
      </IconButton>
      <Modal
        aria-labelledby="info-modal-title"
        aria-describedby="info-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography id="info-modal-title" variant="h5" mb={0.8}>
              Knight's Tour
            </Typography>
            <Typography
              id="info-modal-description"
              variant="body2"
              color={"#e3e3e3"}
              mb={0.4}
            >
              The{" "}
              <Link
                href="https://en.wikipedia.org/wiki/Knight's_tour"
                target="_blank"
              >
                knight's tour
              </Link>{" "}
              is a mathematical problem (or a solution to one) involving one
              knight and a lot of decisions. Using the legal (L-shaped)
              movements of a knight in chess, you must travel to each square on
              the board exactly once, completing the tour. This webapp lets you
              visualize the problem, tweak the constraints (e.g., board size, )
              and auto-move the knight if desired.
            </Typography>
            <Typography variant="caption" color={"#b8b8b8"}>
              This webapp can dynamically implement the{" "}
              <Link
                href="https://en.wikipedia.org/wiki/Knight's_tour#Warnsdorf's_rule"
                target="_blank"
              >
                Warnsdorf's rule
              </Link>{" "}
              heuristic to solve itself if desired. The heuristic dictates that
              the knight must always move to the tile that will provide the
              smallest non-zero number of possible moves.
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default InfoModal;
